import React from 'react';
import BookTreeComponent from './BookTree';
import { range } from 'lodash';
// import { debounce } from 'lodash';
import { TreeInfo } from './Utils';


type Props = {
  data: TreeInfo,
  set_id: (new_id: string) => void,
  data_id: string,
};
type State = {
};

class BookSumBookTree extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
    };
  }

  componentDidUpdate(prevProps: Props) {
    /*
    if (this.props.all_data.id !== prevProps.all_data.id) {
      console.log('Data changed!');
      const relevant_keys = get_relevant_keys(this.props.all_data, null);
      const newState: State = {
        ...
      } as State;
      this.setState(newState as any)
    }
     */
  }

  updateState(update: any) {
    this.setState(update);
    console.log('update', update);
  }

  handleStateChange(key: string, event: any) { // KeyboardEvent
    const update: any = {};
    update[key] = event.target.value;
    this.updateState(update);
  }

  showError(err: any) {
    // TODO: better
    console.error(err);
    alert(err);
  }
  render() {
    console.log('rerender', this.props);
    let [model, numeric_id_str] = this.props.data_id.split("/");
    let numeric_id = parseInt(numeric_id_str)+1;
    return (
      <div>
        <div>
            Book
            <select
              value={numeric_id}
              onChange={(ev) => {
                let new_id: number = parseInt(ev.target.value) - 1;
                if (isNaN(new_id)) { return; }
                console.log("setting", new_id.toString())
                this.props.set_id([model, new_id.toString()].join("/"))
              }}>
              {
                range(1, 269).map((id) => {
                  return <option key={id} value={id}>{id}</option>
                })
              }
            </select>
              {" of 268"}
            <br/>

            Summary model: {" "}
            <select style={{width: '80px'}} value={model}
              onChange={(ev) => {
                this.props.set_id([ev.target.value, numeric_id_str].join("/"))
              }}
            >
              <option value="175b">175B</option>
              <option value="175bfirsttree">175B (trained on first subtree only)</option>
              <option value="6b">6B</option>
            </select>
            <br/>

          <h3>{this.props.data.info.title} </h3>
          <h4>{this.props.data.info.subtitle} </h4>
          <a href={this.props.data.info.url}>
            {this.props.data.info.url}
          </a>
          <br/>
        </div>
        <BookTreeComponent data={this.props.data} is_gutenberg={false}/>
      </div>
    );
  }
}

export default BookSumBookTree;

